import useENotification from '../../../../hooks/eNotification';

function ENotification() {
  const { currentPath, iframeRef } = useENotification();

  return currentPath ? (
    <iframe ref={iframeRef} title="e-notification" src={currentPath} width="100%" height="700px" />
  ) : null;
}

export default ENotification;
